module.exports = __webpack_public_path__ + "1799ea5087931cd435833f1c4d23a350.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-13.png
// module id = 2379
// module chunks = 0